import { wgs84CoordsToDisplay } from './coords';
import { openRingCoords } from './geometry';
import { SELECTED_VERTEX_COLOR } from './constants';

export function featuresToGeoJSON(features, map = null, selectedIds = []) {
  const list = [];
  const selectedSet = new Set(selectedIds || []);
  features.forEach((f) => {
    // feature.coordinates 存 WGS84；上图时按当前底图转为显示坐标
    const displayCoords = wgs84CoordsToDisplay(f.coordinates, map);
    const isSelected = selectedSet.has(f.id);
    if (f.type === 'polygon' || f.type === 'rectangle') {
      const openDisplay = openRingCoords(displayCoords);
      let ring = openDisplay.map((c) => [...c]);
      if (ring.length && (ring[0][0] !== ring[ring.length - 1][0] || ring[0][1] !== ring[ring.length - 1][1])) {
        ring = [...ring, ring[0]];
      }
      list.push({
        type: 'Feature',
        id: f.id,
        properties: {
          id: f.id,
          kind: f.type,
          color: f.color,
          opacity: f.opacity,
          fill: !!f.fill,
          name: f.name || '',
          selected: isSelected
        },
        geometry: { type: 'Polygon', coordinates: [ring] }
      });
      list.push({
        type: 'Feature',
        id: `${f.id}-outline`,
        properties: {
          id: f.id,
          kind: `${f.type}-outline`,
          // 定型后始终用完成色；选中只加粗，避免与绘制预览橙混淆
          color: f.color,
          opacity: f.opacity,
          lineWidth: isSelected ? 5.5 : 3.5,
          fill: false,
          name: f.name || '',
          selected: isSelected
        },
        geometry: { type: 'LineString', coordinates: ring }
      });
      openDisplay.forEach((c, idx) => {
        list.push({
          type: 'Feature',
          id: `${f.id}-p${idx}`,
          properties: {
            id: f.id,
            kind: 'vertex',
            color: isSelected ? SELECTED_VERTEX_COLOR : f.color,
            opacity: 1,
            fill: false
          },
          geometry: { type: 'Point', coordinates: c }
        });
      });
    } else if (f.type === 'sketch') {
      if (displayCoords.length >= 2) {
        list.push({
          type: 'Feature',
          id: f.id,
          properties: {
            id: f.id,
            kind: 'sketch',
            color: f.color,
            opacity: f.opacity,
            lineWidth: (f.lineWidth || 3) + (isSelected ? 2.5 : 0),
            fill: false,
            name: f.name || '',
            selected: isSelected
          },
          geometry: { type: 'LineString', coordinates: displayCoords }
        });
      }
    } else if (f.type === 'text') {
      const anchor = displayCoords[0] || [0, 0];
      list.push({
        type: 'Feature',
        id: f.id,
        properties: {
          id: f.id,
          kind: 'text',
          color: f.color,
          opacity: f.opacity ?? 1,
          fill: false,
          name: f.name || '',
          selected: isSelected
        },
        geometry: { type: 'Point', coordinates: anchor }
      });
    } else {
      // 路线 / 测距：定型后显示完成色；选中加粗 + 紫色顶点
      list.push({
        type: 'Feature',
        id: f.id,
        properties: {
          id: f.id,
          kind: f.type,
          color: f.color,
          opacity: f.opacity,
          lineWidth: isSelected ? 5.5 : 3.5,
          fill: false,
          name: f.name || '',
          selected: isSelected
        },
        geometry: { type: 'LineString', coordinates: displayCoords }
      });
      displayCoords.forEach((c, idx) => {
        list.push({
          type: 'Feature',
          id: `${f.id}-p${idx}`,
          properties: {
            id: f.id,
            kind: 'vertex',
            color: isSelected ? SELECTED_VERTEX_COLOR : f.color,
            opacity: 1,
            fill: false
          },
          geometry: { type: 'Point', coordinates: c }
        });
      });
    }
  });
  return { type: 'FeatureCollection', features: list };
}
